// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1h9j3","col":"Table_col__3wrqg","fulfillmentStatus":"Table_fulfillmentStatus__1CLgc","emailCol":"Table_emailCol__-ZSF5"};